import React from "react";

const IconCamera = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode }) => {
    return (
        <svg
            className={ props?.className }
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 24 24"
        >
            { props?.defs ? props.defs : null }
            <path
                fill={ props?.iconFill }
                fillRule="nonzero"
                d="M22 14.236v3.528l-2-1v-1.528zM24 11l-6 3v4l6 3zm-10 2v5.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V13a6 6 0 0 1-2-.35V19a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6.35a6 6 0 0 1-2 .35m0-8c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2M4 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2m10-2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M4 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8"></path>
        </svg>
    )
};

export default IconCamera;
